module.exports = __webpack_public_path__ + "static/media/teacher6.0a6ad177.svg";